function add_employee(callback) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/employee/add',
        onOpen: function (elm, popup) {

            toggle_employee_roles_toggles(elm);

            elm.find('form').ajaxFormSubmit(function(data){
                elm.find('.max-reached').toggle(data === "max_reached");
                $('body').doneLoading();
                if(data !== "max_reached") {
                    reload_location_if_needed();
                    if (!window.closeWindow) view_employee(data.id);
                    if (callback) {
                        callback(data);
                    }
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan","alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function delete_employee(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);
    confirm("Weet u zeker dat u \""+name+"\" wilt verwijderen?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/employee/delete",
            data: {id:id},
            type: "POST",
            success: function(data) {
                $('[data-object-type=\'employee\'][data-id=\''+id+'\'').remove();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });
    return false;
}
function toggle_employee_roles_toggles(elm) {
    const $ = jQuery.noConflict();
    const wrapper = elm.find('label[for="roles"]');

    wrapper.find('input[type="checkbox"]').change(function() {
        if (elm.find('.max-users-reached-for-this-role').length > 0) {
            const isAllowed = wrapper.find('[data-main-role]:checked').length > 0;
            elm.find('.max-users-reached-for-this-role').each(function() {
                const tr = $(this).parents('tr');
                tr.find('input[type="checkbox"]:not([data-main-role])').prop('disabled', function(i, v) { return !isAllowed; });
                elm.find('.max-users-reached-for-this-role').toggle(!isAllowed);
            });
        }

        let checked = elm.find('label[for="roles"]').find('input[type="checkbox"]:not(:disabled):checked').length;
        if (elm.find('meta[name="id"]:not([content=""])').length > 0) {
            checked = elm.find('label[for="roles"]').find('input[type="checkbox"]:checked').length;
        }
        elm.find('button[type="submit"]').prop('disabled', function(i, v) { return !(checked > 0); });
    }).trigger('change');
}
function view_employee(id, vars) {
    var $ = jQuery.noConflict();

    if(vars != undefined && typeof vars == "function") {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/employee/view/'+id,
        onOpen: function(elm, popup) {

            toggle_employee_roles_toggles(elm);

            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                elm.find('.max-reached').toggle(data === "max_reached");
                if (data !== 'max_reached') {
                    $('body').doneLoading();
                    reload_location_if_needed(document.closeWindow);

                    if(vars && vars.callback) {
                        vars.callback(data, elm, popup);
                    }
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
